import {call, put} from 'redux-saga/effects';
import DiagnosticActions from '../redux/DiagnosticRedux';
import MessagesActions from '../redux/MessagesRedux';

export function * getDiagnostic(api, action) {
  const response = yield call(api.getDiagnostic);
  
  if (response.ok) {
    yield put(DiagnosticActions.diagnosticSuccess(transform(response.data.checks)));
  } else {
    yield put(DiagnosticActions.diagnosticFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

const transform = data => {
  return data && data.length && data.length > 0 ? data.map(itm => ({...itm, state: itm.state ? itm.state.toUpperCase() : null})) : null;
}
